import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { useMemo as $cNx9A$useMemo, useCallback as $cNx9A$useCallback } from "react";
import { useSyncExternalStore as $cNx9A$useSyncExternalStore } from "use-sync-external-store/shim/index.js";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $77b352cf12efcf73$export$c7b26b20d3ced9c5() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$maxVisibleToas = props.maxVisibleToasts,
      maxVisibleToasts = _props$maxVisibleToas === void 0 ? 1 : _props$maxVisibleToas,
      wrapUpdate = props.wrapUpdate;
  var queue = (0, $cNx9A$useMemo)(function () {
    return new $77b352cf12efcf73$export$f1f8569633bbbec4({
      maxVisibleToasts: maxVisibleToasts,
      wrapUpdate: wrapUpdate
    });
  }, [maxVisibleToasts, wrapUpdate]);
  return $77b352cf12efcf73$export$84726ef35ca2129a(queue);
}

function $77b352cf12efcf73$export$84726ef35ca2129a(queue) {
  var subscribe = (0, $cNx9A$useCallback)(function (fn) {
    return queue.subscribe(fn);
  }, [queue]);
  var getSnapshot = (0, $cNx9A$useCallback)(function () {
    return queue.visibleToasts;
  }, [queue]);
  var visibleToasts = (0, $cNx9A$useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
  return {
    visibleToasts: visibleToasts,
    add: function add(content, options) {
      return queue.add(content, options);
    },
    close: function close(key) {
      return queue.close(key);
    },
    pauseAll: function pauseAll() {
      return queue.pauseAll();
    },
    resumeAll: function resumeAll() {
      return queue.resumeAll();
    }
  };
}

var $77b352cf12efcf73$export$f1f8569633bbbec4 = /*#__PURE__*/function () {
  function $77b352cf12efcf73$export$f1f8569633bbbec4(options) {
    _classCallCheck(this, $77b352cf12efcf73$export$f1f8569633bbbec4);

    this.queue = [];
    this.subscriptions = new Set();
    /** The currently visible toasts. */

    this.visibleToasts = [];

    var _options_maxVisibleToasts;

    this.maxVisibleToasts = (_options_maxVisibleToasts = options === null || options === void 0 ? void 0 : options.maxVisibleToasts) !== null && _options_maxVisibleToasts !== void 0 ? _options_maxVisibleToasts : Infinity;
    this.wrapUpdate = options === null || options === void 0 ? void 0 : options.wrapUpdate;
  }

  return _createClass($77b352cf12efcf73$export$f1f8569633bbbec4, [{
    key: "runWithWrapUpdate",
    value: function runWithWrapUpdate(fn, action) {
      if (this.wrapUpdate) this.wrapUpdate(fn, action);else fn();
    }
    /** Subscribes to updates to the visible toasts. */

  }, {
    key: "subscribe",
    value: function subscribe(fn) {
      var _this = this;

      this.subscriptions.add(fn);
      return function () {
        return _this.subscriptions.delete(fn);
      };
    }
    /** Adds a new toast to the queue. */

  }, {
    key: "add",
    value: function add(content) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var toastKey = '_' + Math.random().toString(36).slice(2);

      var toast = _objectSpread(_objectSpread({}, options), {}, {
        content: content,
        key: toastKey,
        timer: options.timeout ? new $77b352cf12efcf73$var$Timer(function () {
          return _this2.close(toastKey);
        }, options.timeout) : undefined
      });

      this.queue.unshift(toast);
      this.updateVisibleToasts('add');
      return toastKey;
    }
    /**
    * Closes a toast.
    */

  }, {
    key: "close",
    value: function close(key) {
      var index = this.queue.findIndex(function (t) {
        return t.key === key;
      });

      if (index >= 0) {
        var _this_queue_index_onClose, _this_queue_index;

        (_this_queue_index_onClose = (_this_queue_index = this.queue[index]).onClose) === null || _this_queue_index_onClose === void 0 ? void 0 : _this_queue_index_onClose.call(_this_queue_index);
        this.queue.splice(index, 1);
      }

      this.updateVisibleToasts('remove');
    }
  }, {
    key: "updateVisibleToasts",
    value: function updateVisibleToasts(action) {
      var _this3 = this;

      this.visibleToasts = this.queue.slice(0, this.maxVisibleToasts);
      this.runWithWrapUpdate(function () {
        var _iterator = _createForOfIteratorHelper(_this3.subscriptions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fn = _step.value;
            fn();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }, action);
    }
    /** Pauses the timers for all visible toasts. */

  }, {
    key: "pauseAll",
    value: function pauseAll() {
      var _iterator2 = _createForOfIteratorHelper(this.visibleToasts),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var toast = _step2.value;
          if (toast.timer) toast.timer.pause();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /** Resumes the timers for all visible toasts. */

  }, {
    key: "resumeAll",
    value: function resumeAll() {
      var _iterator3 = _createForOfIteratorHelper(this.visibleToasts),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var toast = _step3.value;
          if (toast.timer) toast.timer.resume();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.queue = [];
      this.updateVisibleToasts('clear');
    }
  }]);
}();

var $77b352cf12efcf73$var$Timer = /*#__PURE__*/function () {
  function $77b352cf12efcf73$var$Timer(callback, delay) {
    _classCallCheck(this, $77b352cf12efcf73$var$Timer);

    this.startTime = null;
    this.remaining = delay;
    this.callback = callback;
  }

  return _createClass($77b352cf12efcf73$var$Timer, [{
    key: "reset",
    value: function reset(delay) {
      this.remaining = delay;
      this.resume();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.timerId == null) return;
      clearTimeout(this.timerId);
      this.timerId = null;
      this.remaining -= Date.now() - this.startTime;
    }
  }, {
    key: "resume",
    value: function resume() {
      var _this4 = this;

      if (this.remaining <= 0) return;
      this.startTime = Date.now();
      this.timerId = setTimeout(function () {
        _this4.timerId = null;
        _this4.remaining = 0;

        _this4.callback();
      }, this.remaining);
    }
  }]);
}();

export { $77b352cf12efcf73$export$c7b26b20d3ced9c5 as useToastState, $77b352cf12efcf73$export$f1f8569633bbbec4 as ToastQueue, $77b352cf12efcf73$export$84726ef35ca2129a as useToastQueue };